"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.etherscanERC20EventToOperation = exports.etherscanOperationToOperation = exports.transactionToEthersTransaction = void 0;
var eip55_1 = __importDefault(require("eip55"));
var ethers_1 = require("ethers");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var cryptoassets_1 = require("@ledgerhq/cryptoassets");
var account_1 = require("../../account");
var operation_1 = require("../../operation");
/**
 * Adapter to convert a Ledger Live transaction to an Ethers transaction
 */
var transactionToEthersTransaction = function (tx) {
    var ethersTx = {
        to: tx.recipient,
        value: ethers_1.ethers.BigNumber.from(tx.amount.toFixed()),
        data: tx.data ? "0x".concat(tx.data.toString("hex")) : undefined,
        gasLimit: ethers_1.ethers.BigNumber.from(tx.gasLimit.toFixed()),
        nonce: tx.nonce,
        chainId: tx.chainId,
        type: tx.type
    };
    // is EIP-1559 transaction (type 2)
    if (tx.type === 2) {
        ethersTx.maxFeePerGas = ethers_1.ethers.BigNumber.from(tx.maxFeePerGas.toFixed());
        ethersTx.maxPriorityFeePerGas = ethers_1.ethers.BigNumber.from(tx.maxPriorityFeePerGas.toFixed());
    }
    else {
        // is Legacy transaction (type 0)
        ethersTx.gasPrice = ethers_1.ethers.BigNumber.from(tx.gasPrice.toFixed());
    }
    return ethersTx;
};
exports.transactionToEthersTransaction = transactionToEthersTransaction;
/**
 * Adapter to convert an Etherscan-like operation into a Ledger Live Operation
 */
var etherscanOperationToOperation = function (accountId, tx) {
    var address = (0, account_1.decodeAccountId)(accountId).xpubOrAddress;
    var checksummedAddress = eip55_1["default"].encode(address);
    var from = eip55_1["default"].encode(tx.from);
    var to = tx.to ? eip55_1["default"].encode(tx.to) : "";
    var value = new bignumber_js_1["default"](tx.value);
    var fee = new bignumber_js_1["default"](tx.gasUsed).times(new bignumber_js_1["default"](tx.gasPrice));
    var type = (function () {
        if (to === checksummedAddress) {
            return "IN";
        }
        if (from === checksummedAddress) {
            return value.eq(0) ? "FEES" : "OUT";
        }
        return "NONE";
    })();
    return {
        id: (0, operation_1.encodeOperationId)(accountId, tx.hash, type),
        hash: tx.hash,
        type: type,
        value: type === "OUT" || type === "FEES" ? value.plus(fee) : value,
        fee: fee,
        senders: [from],
        recipients: [to],
        blockHeight: parseInt(tx.blockNumber, 10),
        blockHash: tx.blockHash,
        transactionSequenceNumber: parseInt(tx.nonce, 10),
        accountId: accountId,
        date: new Date(parseInt(tx.timeStamp, 10) * 1000),
        extra: {}
    };
};
exports.etherscanOperationToOperation = etherscanOperationToOperation;
/**
 * Adapter to convert an ERC20 transaction received
 * on etherscan-like APIs into an Operation
 */
var etherscanERC20EventToOperation = function (accountId, event) {
    var _a = (0, account_1.decodeAccountId)(accountId), currencyId = _a.currencyId, address = _a.xpubOrAddress;
    var tokenCurrency = (0, cryptoassets_1.findTokenByAddressInCurrency)(event.contractAddress, currencyId);
    if (!tokenCurrency)
        return null;
    var tokenAccountId = (0, account_1.encodeTokenAccountId)(accountId, tokenCurrency);
    var from = eip55_1["default"].encode(event.from);
    var to = event.to ? eip55_1["default"].encode(event.to) : "";
    var value = new bignumber_js_1["default"](event.value);
    var fee = new bignumber_js_1["default"](event.gasUsed).times(new bignumber_js_1["default"](event.gasPrice));
    var type = (function () {
        if (event.contractAddress && to === eip55_1["default"].encode(address)) {
            return "IN";
        }
        if (event.contractAddress && from === eip55_1["default"].encode(address)) {
            return "OUT";
        }
        return "NONE";
    })();
    return {
        tokenCurrency: tokenCurrency,
        operation: {
            id: (0, operation_1.encodeOperationId)(tokenAccountId, event.hash, type),
            hash: event.hash,
            type: type,
            value: value,
            fee: fee,
            senders: [from],
            recipients: [to],
            contract: tokenCurrency.contractAddress,
            blockHeight: parseInt(event.blockNumber, 10),
            blockHash: event.blockHash,
            transactionSequenceNumber: parseInt(event.nonce, 10),
            accountId: tokenAccountId,
            date: new Date(parseInt(event.timeStamp, 10) * 1000),
            extra: {}
        }
    };
};
exports.etherscanERC20EventToOperation = etherscanERC20EventToOperation;
//# sourceMappingURL=adapters.js.map